module.exports = __webpack_public_path__ + "img/ico-password.104c7b24.svg";